const sanitizeFilename = (name) =>
  (name || "samarth_chat").replace(/[^a-z0-9-_]+/gi, "_").slice(0, 80) ||
  "samarth_chat";

const escapePdfHtml = (val) =>
  String(val ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatPdfColumnLabel = (name) =>
  String(name || "")
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase());
const NUMERIC_STRING_RE = /^-?\d*\.?\d+$/;
const ISO_DATE_PREFIX_RE = /^(\d{4}-\d{2}-\d{2})(?:[T ].*)?$/;
const formatPdfCellValue = (val) => {
  if (val === null || val === undefined || val === "") return "-";
  if (typeof val === "number") {
    if (!Number.isFinite(val)) return String(val);
    return String(Math.ceil(val));
  }
  if (typeof val === "string") {
    const trimmed = val.trim();
    const dateMatch = trimmed.match(ISO_DATE_PREFIX_RE);
    if (dateMatch) return dateMatch[1];
    if (NUMERIC_STRING_RE.test(trimmed)) {
      const num = Number(trimmed);
      if (Number.isFinite(num)) return String(Math.ceil(num));
    }
    return val;
  }
  return String(val);
};

const buildTableHtmlFromMsg = (msg) => {
  const columns = Array.isArray(msg?.columns) ? msg.columns.slice(0, 6) : [];
  const rows = Array.isArray(msg?.rows) ? msg.rows.slice(0, 7) : [];

  if (!columns.length || !rows.length) return "";

  const headerCells = columns
    .map((col) => `<th>${escapePdfHtml(formatPdfColumnLabel(col?.name))}</th>`)
    .join("");

  const bodyRows = rows
    .map((row) => {
      const cells = columns
        .map((_, ci) => {
          const cell = Array.isArray(row) ? row[ci] : undefined;
          const display = formatPdfCellValue(cell);
          return `<td>${escapePdfHtml(display)}</td>`;
        })
        .join("");

      return `<tr>${cells}</tr>`;
    })
    .join("");

  return `
    <div class="table-scroll-wrapper">
      <table>
        <thead><tr>${headerCells}</tr></thead>
        <tbody>${bodyRows}</tbody>
      </table>
    </div>
  `;
};
const exportChatAsPdf = (chatNode, exportTitle, messages = []) => {
  if (!chatNode) return;

  const win = window.open("", "");
  if (!win) return;

  const safeTitle = sanitizeFilename(exportTitle);
  const heading = exportTitle || "Samarth Chat";

  const clone = chatNode.cloneNode(true);
  const messagesById = new Map(
    (messages || []).filter((m) => m?.id != null).map((m) => [String(m.id), m]),
  );

  clone.querySelectorAll("[data-export-id]").forEach((node) => {
    const scope = node.getAttribute("data-export-scope");
    if (scope && scope !== "default") {
      node.remove();
      return;
    }
    const id = node.getAttribute("data-export-id");
    const msg = messagesById.get(String(id));
    const tableHtml = buildTableHtmlFromMsg(msg);
    node.innerHTML = tableHtml;
  });
  clone
    .querySelectorAll(".recharts-tooltip-wrapper")
    .forEach((el) => el.remove());
  clone.querySelectorAll("table").forEach((table) => {
    if (table.closest(".table-scroll-wrapper")) return;
    const wrapper = document.createElement("div");
    wrapper.className = "table-scroll-wrapper";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  const inheritedStyles = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style'),
  )
    .map((el) => {
      if (el.tagName === "LINK") {
        return el.href ? `<link rel="stylesheet" href="${el.href}">` : "";
      }
      // <style>
      try {
        const sheet = el.sheet;
        if (sheet && sheet.cssRules && sheet.cssRules.length) {
          const rules = Array.from(sheet.cssRules)
            .map((r) => r.cssText)
            .join("\n");
          const attrs = Array.from(el.attributes)
            .map(
              (a) => `${a.name}="${String(a.value).replace(/"/g, "&quot;")}"`,
            )
            .join(" ");
          return `<style ${attrs}>${rules}</style>`;
        }
      } catch {
        // Cross-origin stylesheet — cssRules access throws. Fall through.
      }
      return el.outerHTML;
    })
    .join("\n");

  win.document.open();
  win.document.write(`
  <html>
    <head>
      <title>${safeTitle}</title>
      ${inheritedStyles}
      <style>
        @page {
  size: A4 landscape;
  margin: 8mm;
}

html,
body {
  width: 100%;
  margin: 0;
  padding: 0;
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

body {
  padding: 12px;
  color: #1A2025;
  box-sizing: border-box;
}

h2 {
  margin: 0 0 12px;
  font-size: 16px;
}

/* hide controls */
button,
input,
textarea {
  display: none !important;
}

/* root print area */
.print-stage {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* prevent layout breaking */
* {
  box-sizing: border-box;
}

/* tables */
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  margin-bottom: 16px;
  border: 1px solid #D9E1E7;
  page-break-inside: avoid;
  break-inside: avoid;
}

.table-scroll-wrapper table {
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 10px;
  text-align:center;
}

.table-scroll-wrapper th,
.table-scroll-wrapper td {
  border: 1px solid #D9E1E7;
  padding: 3px 5px;
  line-height: 1.2;
  white-space: nowrap;
  vertical-align: top;
}

/* charts */
.chart-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 20px;
  page-break-inside: avoid;
  break-inside: avoid;
}

/* VERY IMPORTANT */
.recharts-wrapper,
.recharts-responsive-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

/* svg fix */
svg {
  max-width: 100% !important;
  height: auto !important;
  overflow: visible !important;
}

/* avoid chart clipping */
.recharts-surface {
  overflow: visible !important;
}

/* images */
img,
canvas {
  max-width: 100% !important;
}

/* page break handling */
table,
svg,
img,
canvas {
  page-break-inside: avoid;
  break-inside: avoid;
}
 
      </style>
    </head>
 
    <body>
      <h2>${heading}</h2>
      <div class="print-stage">
        ${clone.outerHTML}
      </div>
    </body>
  </html>
  `);

  win.document.close();
  win.focus();
  win.onload = () => {
    setTimeout(() => {
      win.focus();
      win.print();
    }, 1500);
  };
};

export default exportChatAsPdf;
